<template>
    <v-row>
        <v-col>
            <v-card class="pa-4">
                <v-card-title>{{ entity.phone }}</v-card-title>
                <v-card-text>
                    <UserTabLinks />
                    <v-row class="pl-3 pb-3" />
                    <v-row form class="form-group">
                        <v-col sm="3">Телефон</v-col>
                        <v-col sm="9">{{ entity.phone }}</v-col>
                    </v-row>
                    <v-row form class="form-group" v-if="isAdmin">
                        <v-col sm="3">Админ</v-col>
                        <v-col sm="9">
                            <span :class="`true-false-label ${getBadge(entity.admin)}`">
                                &nbsp;{{entity.admin ? 'Да' : 'Нет' }}&nbsp;
                            </span>
                        </v-col>
                    </v-row>
                    <v-row form class="form-group" v-if="isAdmin">
                        <v-col sm="3">Партнер</v-col>
                        <v-col sm="9">
                            <span :class="`true-false-label ${getBadge(entity.partner)}`">
                                &nbsp;{{entity.partner ? 'Да' : 'Нет' }}&nbsp;
                            </span>
                        </v-col>
                    </v-row>
                    <template v-if="isAdmin && entity.partner">
                        <v-row form class="form-group">
                            <v-col sm="3">Отправлять смс при входе</v-col>
                            <v-col sm="9">
                                <span :class="`true-false-label ${getBadge(entity.login_sms)}`">
                                    &nbsp;{{ entity.login_sms ? 'Да' : 'Нет' }}&nbsp;
                                </span>
                            </v-col>
                        </v-row>
                        <v-row v-if="!entity.login_sms" form class="form-group">
                            <v-col sm="3">Пароль</v-col>
                            <v-col sm="9">{{ entity.login_password || '—' }}</v-col>
                        </v-row>
                    </template>
                    <v-row form class="form-group">
                        <v-col sm="3">Имя</v-col>
                        <v-col sm="9">{{ entity.firstname }}</v-col>
                    </v-row>
                    <v-row form class="form-group">
                        <v-col sm="3">Фамилия</v-col>
                        <v-col sm="9">{{ entity.lastname }}</v-col>
                    </v-row>
                    <v-row form class="form-group" v-if="isAdmin">
                        <v-col sm="3">Активен</v-col>
                        <v-col sm="9">
                            <span :class="`true-false-label ${getBadge(entity.enabled)}`">
                                &nbsp;{{entity.enabled ? 'Да' : 'Нет' }}&nbsp;
                            </span>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="pa-4 d-flex justify-space-between">
                    <div>
                        <v-btn
                            color="light"
                            class="mr-3"
                            @click="goBack"
                        >К списку</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import store from '../../store';
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { mapState } from 'vuex';
    import UserTabLinks from '../../components/users/UserTabLinks';

    import { imageSrc } from '../../helpers';

    export default {
        name: 'UserDetail',

        components: {
            UserTabLinks,
        },

        data() {
            return {
                imageSrc,
                deleteModal: false,
            };
        },

        computed: {
            ...mapState('auth', ['user']),
            ...mapState('users', {
                entity: state => state.entity
            }),
            isAdmin() {
                return this.user.admin;
            },
            siteType() {
                const type = this.siteTypes.find(item => item.id === this.entity.site_type_id);
                return type ? type.title : '';
            }
        },

        async mounted() {
            const id = this.$route.params.id;
            await store.dispatch('siteTypes/fetch');
            if(id) {
                await store.dispatch('users/get', {id});
            }
        },

        methods: {
            getBadge (status) {
                return status ? 'success' : 'error';
            },
            goBack() {
                this.$router.push({ path: '/users' });
            },
        },
    };
</script>